import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheckIcon, HeadphonesIcon, RocketIcon } from "./Icons";

function Footer() {
  return (
    <footer className="public-footer">
      <div className="container">
        {/* Top Footer Grid */}
        <div className="footer-top-grid">
          {/* Brand Column */}
          <div className="footer-col-brand">
            <div className="footer-brand-header">
              <span className="footer-brand-title">IM ONLINE</span>
              <span className="footer-brand-badge">SELLER CENTER</span>
            </div>
            <p className="footer-brand-desc">
              India's dedicated marketplace and seller platform for sneaker, footwear, and fashion merchants. Start selling online with 2-minute onboarding, transparent plans, and zero hidden fees.
            </p>
            <div className="footer-trust-pill">
              <ShieldCheckIcon size={16} color="#a85050" />
              <span>100% Verified Seller Platform</span>
            </div>
          </div>

          {/* Column 1: Platform */}
          <div className="footer-col">
            <h6 className="footer-col-title">Platform</h6>
            <ul className="footer-links-list">
              <li><a href="/vendor#our-agenda">Our Mission &amp; Agenda</a></li>
              <li><a href="/vendor#how-it-works">How It Works</a></li>
              <li><a href="/vendor#pricing">Pricing Plans</a></li>
              <li><Link to="/vendor/requirements">Seller Requirements</Link></li>
              <li><a href="/vendor#dashboard-preview">Dashboard Preview</a></li>
              <li><a href="/vendor#why-sell">Why Sell With Us</a></li>
            </ul>
          </div>

          {/* Column 2: Seller Resources */}
          <div className="footer-col">
            <h6 className="footer-col-title">Seller Resources</h6>
            <ul className="footer-links-list">
              <li><Link to="/vendor/register">Create Seller Account</Link></li>
              <li><Link to="/vendor/login">Seller Center Login</Link></li>
              <li><Link to="/vendor/requirements">Document Checklist</Link></li>
              <li><a href="/vendor#pricing">Fee Calculator</a></li>
              <li><a href="/vendor#faq">Seller FAQ</a></li>
            </ul>
          </div>

          {/* Column 3: Support */}
          <div className="footer-col">
            <h6 className="footer-col-title">Support</h6>
            <ul className="footer-links-list">
              <li>
                <a href="mailto:support@imonline.shop" className="footer-contact-link">
                  <HeadphonesIcon size={14} />
                  <span>support@imonline.shop</span>
                </a>
              </li>
              <li><span className="footer-subtext">Mon - Sat: 9:00 AM - 7:00 PM</span></li>
              <li><a href="/vendor#faq">Dispute Resolution</a></li>
              <li><a href="/vendor#faq">Seller Protection Policy</a></li>
            </ul>
          </div>

          {/* Column 4: Quick Action CTA Card */}
          <div className="footer-col footer-col-cta">
            <div className="footer-cta-card">
              <div className="footer-cta-icon-wrap">
                <RocketIcon size={20} color="#a85050" />
              </div>
              <h6 className="footer-cta-heading">Ready to Start?</h6>
              <p className="footer-cta-sub">
                Launch your footwear storefront today with 0% commission options.
              </p>
              <Link to="/vendor/register" className="btn-primary w-100" style={{ padding: "10px 18px", fontSize: "13px" }}>
                Start Selling Free &rarr;
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Footer Bar */}
        <div className="footer-bottom-bar">
          <div className="footer-bottom-left">
            <span>&copy; {new Date().getFullYear()} IM Online Seller Center. All rights reserved.</span>
          </div>
          <div className="footer-bottom-links">
            <a href="/vendor#faq">Privacy Policy</a>
            <span className="dot-sep">&middot;</span>
            <a href="/vendor#faq">Terms of Service</a>
            <span className="dot-sep">&middot;</span>
            <a href="https://www.imonline.shop" target="_blank" rel="noreferrer">
              imonline.shop
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
